export interface MemoizeComparator<P extends any[] = any[]> {
  (args1: P, args2: P): boolean;
}

export function memoizeDefaultComparator<P extends any[]>(args1: P, args2: P) {
  return args1.length === args2.length && args1.every((arg1, i) => Object.is(arg1, args2[i]));
}

export function memoizeFactory<T extends (...args: any[]) => R, R extends any>(
  fn: T,
  comparator: MemoizeComparator = memoizeDefaultComparator
): T {
  const argsEntries: any[][] = [];
  const cache: {[key: number]: R} = {};
  return <any>((...args: any[]) => {
    const foundIndex = argsEntries.findIndex((_args) => comparator(_args, args));
    if (foundIndex !== -1) {
      return cache[foundIndex];
    }
    const result = fn(...args);
    cache[argsEntries.push(args) - 1] = result;
    return result;
  });
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/memoize-factory.ts